export default __webpack_public_path__ + "static/media/PostgreSQL-WindowsTaskScheduler-Action-StartaProgram06.694e80ce.png";